var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[(_vm.select === 0)?_c('ServiceCasesWidget',{attrs:{"data":_vm.loopData0},on:{"select":_vm.handleSelect}}):_c('CaseWidget',{attrs:{"data":_vm.selectData},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }